import { useTranslation } from 'react-i18next';
import type { PreVisitQuestion } from '@/api/preVisit/preVisitApi.types';
import { Label } from '@/components/ui/label';
import { resolveLocalizedText } from '@/utils/localizedText';

interface PreVisitQuestionLabelProps {
  question: PreVisitQuestion;
  htmlFor?: string;
}

export function PreVisitQuestionLabel({ question, htmlFor }: PreVisitQuestionLabelProps) {
  const { t, i18n } = useTranslation('intake');
  const label = resolveLocalizedText(question.labelEn, question.labelPl, i18n.language);
  const help = resolveLocalizedText(question.helpEn === null ? '' : question.helpEn, question.helpPl === null ? '' : question.helpPl, i18n.language);

  return (
    <div className="space-y-0.5">
      <Label htmlFor={htmlFor} isUppercase={false} className="text-sm font-semibold text-zooindigo normal-case tracking-normal">
        {label}
        {question.isRequired ? (
          <span className="text-zooerrortext ml-1" aria-label={t('preVisit.requiredMarker')}>
            *
          </span>
        ) : null}
      </Label>
      {help.length === 0 ? null : <p className="text-xs text-zoomuted">{help}</p>}
    </div>
  );
}
